
    <form [formGroup]="firstQuestionFormGroup" class="wizard-item">
        <div class="row">
            <div class="col-12 wizard-question">
                <ng-container *ngIf="DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id === contractModificationRequest.dictionaryModificationTypeId; else INSTALLMENTDEFERRAL">
                    <span *ngIf="DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id === contractModificationRequest.dictionaryReimbursementTypeId">
                        {{'contractModifications.wizard.questions.WhyDoYouWantToMakeAPartialReimbursement' | translate}}
                    </span>

                    <span *ngIf="DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT?.id === contractModificationRequest.dictionaryReimbursementTypeId">
                        {{'contractModifications.wizard.questions.WhyDoYouWantToMakeAFullReimbursement' | translate}}
                    </span>
                </ng-container>

                <ng-template #INSTALLMENTDEFERRAL>
                    <span>
                        {{'contractModifications.wizard.questions.WhyDoYouWantToPostponeTheInstallment' | translate}}
                    </span>
                </ng-template>
            </div>
        </div>
        <ng-container *ngFor="let reason of contractModificationRequestReasonDatasource; let indexReason = index">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container"
                    [ngClass]="{'textarea-option': reason.code.includes('OTHER')}"
                >
                    <input class="radio-input" type="radio" kendoRadioButton size="large"
                        id="reason-{{reason.id}}"
                        name="answear"
                        [value]="reason.id"
                        [(ngModel)]="firstQuestionFormGroup.value.answear"
                        formControlName="answear"
                        required
                    >
                    <label HJSuppress class="radio-label" for="reason-{{reason.id}}">
                        {{reason.value}}
                        <kendo-textarea *ngIf="reason.code.includes('OTHER')"
                            placeholder="{{'contractModifications.wizard.placeholder.mentionReason' | translate}}"
                            class="textarea-input"
                            name="other-textarea"
                            resizable="none"
                            formControlName="reason"
                            [(ngModel)]="firstQuestionFormGroup.value.reason"
                        >
                        </kendo-textarea>
                    </label>
                </div>
            </div>
        </ng-container>


        <div *ngIf="contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id">
            <div class="row justify-content-center l-uploader-container">
                <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4">
                    <contract-modification-uploader
                        [contractModificationRequest]="contractModificationRequest"

                        [deleteFileHandler]="deleteFileHandler"
                        [uploadFilesHandler]="uploadFilesHandler"
                    >
                    </contract-modification-uploader>
                </div>
            </div>
        </div>


        <div class="d-flex justify-content-center l-next-step-container">
            <button class="btn primary-btn"
                [disabled]="isNextButtonDisabled"
                (click)="nextStepHandler(wizardStepsEnum.ContractModification_Why, firstQuestionFormGroup.value.answear)"
            >
                {{'contractModifications.wizard.continueBtn' | translate}}
            </button>
        </div>

    </form>
